import { createFileRoute } from '@tanstack/react-router';
import Administration from '../../../administration/src/Administration';

export const Route = createFileRoute('/_secured/administration')({
  component: Administration,
});
